import React, { createContext } from 'react';
import { useIntl } from 'react-intl';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

type HeaderContextValues = {
  title: string;
  subtitle: string;
  hasTertiaryArea: boolean;
  moduleType?: string;
};
export const HeaderContext = createContext<HeaderContextValues | undefined>(
  undefined
);

type HeaderContextProps = {
  children:
    | React.ReactNode
    | ((context: HeaderContextValues) => React.ReactNode);
  moduleType?: string;
};
export const HeaderContextProvider: React.FC<HeaderContextProps> = ({
  moduleType,
  children,
}) => {
  const { $t } = useIntl();
  const { isLoggedIn } = useLoginState();
  const { pageContext, isSubpage } = usePageContext();

  const { pageTitle, pageSlogan, socialProof, isEBP } = pageContext;

  let title = pageTitle;
  if (isSubpage && moduleType) {
    title = $t({ id: `EP_${moduleType.toUpperCase()}_DESCRIPTION` });
  }

  let subtitle = isEBP ? pageSlogan : '';
  if (isSubpage || !pageSlogan) {
    subtitle = pageTitle;
  }

  const socialProofTotal = socialProof?.total || 0;
  const hasSomeSocialProof = socialProofTotal > 0;

  const hasTertiaryArea = isLoggedIn && !isSubpage && hasSomeSocialProof;

  return (
    <HeaderContext.Provider
      value={{ title, subtitle, hasTertiaryArea, moduleType }}
    >
      {typeof children === 'function'
        ? children({ title, subtitle, hasTertiaryArea })
        : children}
    </HeaderContext.Provider>
  );
};
